export default __webpack_public_path__ + "static/media/bv.a02e7848.jpg";